import color from "color";

const getBorderColor = (hexColor: string) => color(hexColor).darken(0.2).hex();

export default getBorderColor;
